import { createI18n } from 'vue-i18n'
import zh from './locales/zh-CN.json'
import en from './locales/en-US.json'
import fallZh from '@/monitor-console/fall-detect/i18n/zh-CN.js'
import fallEn from '@/monitor-console/fall-detect/i18n/en.js'
import { mergeFallDetectLocale } from '@/monitor-console/fall-detect/utils/mergeFallDetectLocale'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'zh-CN',
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': mergeFallDetectLocale(zh, fallZh),
    zh: mergeFallDetectLocale(zh, fallZh),
    'en-US': mergeFallDetectLocale(en, fallEn),
    en: mergeFallDetectLocale(en, fallEn)
  }
})

export default i18n
